import { combineReducers, configureStore } from '@reduxjs/toolkit';
import newsReducer from './NewsSlice';
import { newsService } from '../services/newsService';

const rootReducer = combineReducers({
  news: newsReducer,
  [newsService.reducerPath]: newsService.reducer,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(newsService.middleware),
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;

export default rootReducer;
